export default __webpack_public_path__ + "assets/webgl/complete-5.b25b58f8.jpg";